const pastDateFromToday = (numberOfDays: number) => {
  return new Date(
    new Date(
      new Date().setDate(new Date().getDate() - numberOfDays)
    ).setUTCHours(0)
  ).toLocaleDateString("fr-CA");
};
export default pastDateFromToday;
